import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { getPreferredLanguageCode } from 'shared/lib';
import { useInfoStore } from 'store/useInfoStore';

import SignupStep3 from '../signup/SignupStep3';
import OnboardingFinishStep, { type OnboardingForm } from './OnboardingFinishStep';

type ProfileCompletionFormProps = {
  initialForm?: Partial<OnboardingForm>;
  isInline?: boolean;
  onComplete: () => void;
  onSkip?: () => void;
};

/** 홈 모달과 Account 페이지가 같은 입력·동의·완료 처리를 사용한다. */
const ProfileCompletionForm = ({ initialForm, isInline = false, onComplete, onSkip }: ProfileCompletionFormProps) => {
  const { i18n } = useTranslation('auth');
  const { firstName, lastName } = useInfoStore();
  const [form, setForm] = useState<OnboardingForm>(() => ({
    firstName,
    lastName,
    gender: '',
    birthday: '',
    countryCode: '',
    phoneNumber: '',
    nationality: '',
    occupation: '',
    visaInfo: '',
    preferredLanguageCode: getPreferredLanguageCode(i18n.language),
    ...initialForm,
  }));

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'onboarding_view', method: 'google' });
  }, []);

  const handleInputChange = (field: string, value: string) => {
    setForm((previous) => ({ ...previous, [field]: value }));
  };

  return (
    <SignupStep3
      form={form}
      onInputChange={handleInputChange}
      renderForm={(fields, validateDetails) => (
        <OnboardingFinishStep
          form={form}
          onInputChange={handleInputChange}
          onClickNext={onComplete}
          onSkip={onSkip}
          validateDetails={validateDetails}
          isInline={isInline}
        >
          {fields}
        </OnboardingFinishStep>
      )}
    />
  );
};

export default ProfileCompletionForm;
